import { Box } from "@mantine/core"
import { SVGProps } from "react"

export const Logo = (props: SVGProps<SVGSVGElement>) => (
  <Box pos="relative" h={32} w={250}>
    <svg
      id="Calque_1"
      data-name="Calque 1"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        position: "absolute",
        top: 7,
        left: 0,
      }}
      {...props}
    >
      <defs>
        <style>
          {`.cls-1 {
        fill: var(--sidebar-color);
      }

      .cls-2 {
        opacity: .45;
     `}
        </style>
      </defs>
      <path
        className="cls-1"
        d="M41.45,75.79v49.02c0,9.46,6.02,15.05,16.21,15.05,4.79,0,9.88-1.24,13.43-3.26v19.86c-6.02,2.79-14.36,4.65-22.08,4.65-21.61,0-34.27-12.1-34.27-32.89v-52.59H.39v-18.31h16.21V23.35h26.71v8.53c0,13.03-9.73,22.18-25.94,25.13v.47h55.58v18.46h-31.49v-.16Z"
      />
      <path
        className="cls-1"
        d="M163.41,58.57l-7.72,23.89c-4.01-2.33-9.11-3.72-14.2-3.72-15.59,0-24.85,12.72-24.85,34.28v46.07h-26.71V57.48h26.71v42.04h.46c0-27.77,11.58-44.06,30.72-44.06,5.87,0,11.58,1.09,15.59,3.1Z"
      />
      <path
        className="cls-1"
        d="M247.23,108.21c0-18.93-9.42-31.8-25.63-31.8s-25.63,11.94-25.63,31.8,9.42,31.65,25.63,31.65,25.63-12.88,25.63-31.65ZM272.55,57.33v101.92h-26.71v-35.06h-.46c0,23.27-13.43,37.08-36.12,37.08-25.47,0-40.29-19.7-40.29-52.9s14.97-52.9,40.29-52.9c22.69,0,36.12,13.81,36.12,36.92h.46v-35.06h26.71Z"
      />
      <path
        className="cls-1"
        d="M293.39,108.21c0-33.2,19.6-52.9,52.33-52.9,27.63,0,45.69,14.58,49.71,39.71h-26.24c-3.4-11.79-11.58-18.62-23.46-18.62-15.75,0-25.01,11.94-25.01,31.8s9.26,31.65,25.01,31.65c12.5,0,20.84-7.29,23.77-19.86h26.24c-3.86,26.22-21.77,41.11-50.02,41.11-32.88.15-52.33-19.55-52.33-52.9Z"
      />
      <path
        className="cls-1"
        d="M435.42,102.16h47.7c-1.54-17.06-10.34-26.84-23.62-26.84s-22.23,9.77-24.08,26.84ZM509.21,111.31h-73.95c.93,18.62,9.88,29.63,24.24,29.63,12.5,0,21.15-6.98,23.77-18.15h25.94c-3.7,24.2-22.23,38.32-49.71,38.32-31.49,0-50.02-19.7-50.02-52.9s18.52-52.9,50.02-52.9,49.71,19.55,49.71,52.9v3.1Z"
      />
      <g className="cls-2">
        <path
          className="cls-1"
          d="M605.85,41.19v16.29h31.96v18.46h-30.57v83.3h-26.71v-83.3h-15.28v-18.62h39.52v-.47c-16.21-3.1-25.63-12.1-25.63-25.13,0-19.55,14.82-30.87,39.52-30.87,8.65,0,17.29,1.86,24.24,5.12l-3.4,20.17c-4.01-2.48-9.11-3.88-14.36-3.88-12.66,0-19.45,7.14-19.3,18.93Z"
        />
        <path
          className="cls-1"
          d="M723.17,108.21c0-19.86-9.42-31.8-25.63-31.8s-25.63,11.94-25.63,31.8,9.42,31.65,25.63,31.65,25.63-11.64,25.63-31.65ZM644.6,108.21c0-33.2,19.76-52.9,52.8-52.9s52.64,19.7,52.64,52.9-19.6,52.9-52.64,52.9c-33.04.15-52.8-19.55-52.8-52.9Z"
        />
        <path
          className="cls-1"
          d="M844.2,58.57l-7.72,23.89c-4.01-2.33-9.11-3.72-14.2-3.72-15.59,0-24.85,12.72-24.85,34.28v46.07h-26.71V57.48h26.71v42.04h.46c0-27.77,11.58-44.06,30.72-44.06,5.87,0,11.58,1.09,15.59,3.1Z"
        />
        <path
          className="cls-1"
          d="M969.87,107.74c0-18.46-9.42-31.18-25.63-31.18s-25.63,11.79-25.63,31.18,9.42,31.02,25.63,31.02,25.63-12.56,25.63-31.02ZM995.03,57.33v103.01c0,29.79-18.99,47.47-50.94,47.47-27.48,0-46-13.5-49.71-36.46l25.16-3.88c1.54,11.94,10.96,19.08,24.39,19.08,15.13,0,24.24-9.15,24.24-24.51v-38.94h-.46c0,23.11-13.43,36.92-36.12,36.92-25.47,0-40.29-19.55-40.29-52.28s14.97-52.28,40.29-52.28c22.69,0,36.12,13.81,36.12,36.92h.46v-35.06h26.86Z"
        />
        <path
          className="cls-1"
          d="M1094.45,108.21c0-19.86-9.42-31.8-25.63-31.8s-25.63,11.94-25.63,31.8,9.42,31.65,25.63,31.65,25.63-11.64,25.63-31.65ZM1015.87,108.21c0-33.2,19.76-52.9,52.8-52.9s52.64,19.7,52.64,52.9-19.61,52.9-52.64,52.9c-33.04.15-52.8-19.55-52.8-52.9Z"
        />
        <path
          className="cls-1"
          d="M1173.02,108.21c0-19.86-9.41-31.8-25.62-31.8s-25.63,11.94-25.63,31.8,9.42,31.65,25.63,31.65,25.62-11.64,25.62-31.65ZM1094.45,108.21c0-33.2,19.76-52.9,52.79-52.9s52.65,19.7,52.65,52.9-19.61,52.9-52.65,52.9c-33.03.15-52.79-19.55-52.79-52.9Z"
        />
        <path
          className="cls-1"
          d="M1294.06,108.36c0-18.93-9.42-31.8-25.63-31.8s-25.63,11.94-25.63,31.8,9.42,31.65,25.63,31.65,25.63-13.03,25.63-31.65ZM1319.37,3.03v156.21h-26.7v-35.06h-.47c0,23.27-13.43,37.08-36.12,37.08-25.47,0-40.29-19.7-40.29-52.9s14.97-52.9,40.29-52.9c22.69,0,36.12,13.81,36.12,36.92h.47V3.03h26.7Z"
        />
      </g>
    </svg>
  </Box>
)
